<div class="monthly-report-warning">
  <div class="warning-icon">
    <i class="cds-icon-info-circle"></i>
  </div>
  <div class="warning-message">
    <h4>Aviso sobre o Relatório Demonstrativo Financeiro Mensal</h4>
    <p>
      Os dados apresentados neste relatório são provenientes das contas e instituições financeiras conectadas via Open Finance à nossa plataforma.<br>
      É importante destacar que os valores e informações aqui exibidos podem não refletir 100% da situação financeira da empresa, especialmente se existirem contas ou ativos que não estejam conectados ou integrados ao sistema por meio do Open Finance.<br>
      Para uma análise mais precisa e completa, recomendamos que todas as contas relevantes da empresa sejam devidamente vinculadas. Caso contrário, os relatórios podem apresentar lacunas ou valores parciais que não representam o demonstrativo financeiro integral.
    </p>
  </div>
</div>
